export default __webpack_public_path__ + "static/media/slide--4.5e5f58dd.jpg";